import { Sparkline } from '../core/sparkline.js';

/**
 * KPI Bento strip: download / upload / peers / disk
 *
 * Sparklines are populated incrementally from `vitals` events.
 * Disk bar fills horizontally based on data_pct.
 */
export class KpiStrip {
  constructor() {
    this.downSpark = new Sparkline(document.querySelector('[data-spark="down"]'), { minScale: 1024 });
    this.upSpark   = new Sparkline(document.querySelector('[data-spark="up"]'),   { minScale: 1024 });
  }

  apply(vitals) {
    this._setVitals(vitals);
    this.downSpark.push(vitals.rt?.downBytes ?? 0);
    this.upSpark.push(vitals.rt?.upBytes ?? 0);

    // Disk bar fill
    const fill = document.querySelector('[data-fill="disk"]');
    if (fill && vitals.disk?.data_pct != null) {
      fill.style.width = vitals.disk.data_pct + '%';
      fill.classList.toggle('is-warn', vitals.disk.data_pct >= 85);
      fill.classList.toggle('is-error', vitals.disk.data_pct >= 95);
    }
  }

  _setVitals(vitals) {
    for (const el of document.querySelectorAll('[data-vital]')) {
      const path = el.dataset.vital.split('.');
      let v = vitals;
      for (const k of path) v = v?.[k];
      if (v != null) {
        const old = el.textContent;
        const next = String(v);
        if (old !== next) {
          el.textContent = next;
          // brief flash on KPI value
          if (el.classList.contains('kpi__value')) {
            el.classList.remove('is-flash');
            void el.offsetWidth;   // force reflow
            el.classList.add('is-flash');
          }
        }
      }
    }
  }
}
